import React from 'react'

export default class CaseStudy extends React.Component {
  render() {
    return (
      <div className="case-study">
        <h4 className="case-study-header">{this.props.title} &ndash; {this.props.time}</h4>
        <p>
          {this.props.description}
          {this.props.link && <a href={this.props.link} target="_blank"> Check it out.</a>}
        </p>
        <div className="case-study-details">
          {this.props.details &&
            this.props.details.map((detail, i) => {
              const floatDir = (i % 2 === 0) ? 'left' : 'right'
              return (
                <div className={'case-study-detail case-study-detail--' + floatDir} key={i}>
                  <h5>{detail.title}</h5>
                  <ul>
                    {detail.deets &&
                      detail.deets.map((deets, iSub) =>
                        <li key={iSub}>{deets}</li>
                      )
                    }
                  </ul>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page-specific/work/CaseStudy.js